import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandVocabularyPopup = loadAsyncComponent(() => import('./View'), 'popup');
